import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SecurityContext,
  SimpleChanges
} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {CalculatedBlockAttributeStore} from '@shared/rex/calculated-block-attribute.store';
import {Subscription} from 'rxjs';
import {Html, RexCalculationType} from '@paperlessio/sdk/api/models'
import {BlockChangeDetectionService} from '@blocks/services/block-change-detection/block-change-detection.service';
import {filter} from 'rxjs/operators';
import {BLOCKS_CONFIG} from '@blocks/blocks.config';
import {Router} from '@angular/router';

@Component({
  selector: 'app-html',
  templateUrl: './html.component.html',
  styleUrls: ['./html.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HtmlComponent implements OnInit, OnChanges, OnDestroy {
  @Input() block: Html;
  @Input() slug: string;

  private sanitizer = inject(DomSanitizer);

  private calculatedBlockAttributeStore = inject(CalculatedBlockAttributeStore);
  private blockChangeDetectionService = inject(BlockChangeDetectionService);
  private cdr = inject(ChangeDetectorRef);
  private router = inject(Router);
  protected blocksConfig = inject(BLOCKS_CONFIG);

  protected html: string;
  private subs = new Subscription();

  ngOnInit() {
    this.subs.add(
      this.calculatedBlockAttributeStore.blockAttributeValue<string>(this.slug, 'html').subscribe(html => {
        this.update(html);
      })
    );

    this.subs.add(this.blockChangeDetectionService.changedBlockIds$.pipe(
      filter(blockId => blockId === this.block.id)
    ).subscribe(() => {
      this.update();
    }));
  }

  ngOnChanges(changes: SimpleChanges) {
    this.update();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  @HostListener('dblclick', ['$event'])
  onDoubleClick(event: MouseEvent) {
    if (this.blocksConfig.editable) {
      event.stopPropagation();
      event.preventDefault();
      this.router.navigate(['', {outlets: {modal: ['m', 'blocks', this.block.id, 'edit', 'html']}}]);
    }
  }

  private update(html?: string) {
    let unsafeHtml: string;
    switch (this.block.html_calculation_type) {
      case RexCalculationType.CONSTANT:
        unsafeHtml = this.block.html;
        break;
      case RexCalculationType.LIQUID:
        unsafeHtml = html ?? this.html ?? '';
        break;
      case RexCalculationType.JAVASCRIPT:
        unsafeHtml = html ?? this.html ?? '';
        break;
    }

    this.html = this.sanitizer.sanitize(SecurityContext.HTML, unsafeHtml);
    this.cdr.markForCheck();
  }
}
